<label class="tag-selector">
  <span>{{ label }}</span>

  <div class="tag-selector-field">
    <input
      [(ngModel)]="pendingTag"
      [attr.list]="datalistId"
      [placeholder]="placeholder"
      (keydown)="handlePendingTagKeydown($event)"
      (keydown.enter)="addPendingTag(); $event.preventDefault()" />
    <button type="button" class="ghost small" (click)="addPendingTag()">Add</button>
  </div>

  <datalist [id]="datalistId">
    @for (tag of availableSuggestions; track tag) {
      <option [value]="tag"></option>
    }
  </datalist>

  @if (availableSuggestions.length) {
    <div class="tag-suggestions">
      @for (tag of availableSuggestions; track tag) {
        <button type="button" class="ghost small" (click)="addSuggestion(tag)">{{ tag }}</button>
      }
    </div>
  }

  @if (tags.length) {
    <div class="tag-list">
      @for (tag of tags; track tag) {
        <button type="button" class="tag-chip" (click)="removeTag(tag)">
          <span>{{ tag }}</span>
          <span aria-hidden="true">×</span>
        </button>
      }
    </div>
  }
</label>
